/* R24 · Farbgruppe (Owner 30.09.2026) — dieselbe Küche in anderen Farben als EIN Produkt erleben.
 * Markup: snippets/r24-farbgruppe.liquid. Ohne dieses Skript ist jeder Farbpunkt ein normaler Link.
 *
 * 1 · Karte: Maus über einem Farbpunkt = Bild-Vorschau; Klick = die ganze Karte zeigt diese Farbe
 *     (Bild, Titel, Preis, Links, Merkliste, Warenkorb-Variante). Ein Klick auf die schon gezeigte Farbe öffnet das Produkt.
 * 2 · Raster: je Farbgruppe nur EINE sichtbare Karte (data-fg) — auch nach „Mehr laden“ / Filterwechsel. Die erste der
 *     Liste bleibt (so zeigt eine Farb-Kollektion/ein Farb-Filter die passende Farbe). Keine Karte wird entfernt, nur verborgen.
 * 3 · Produktseite: beim Wechsel der Farbe bleibt die Scrollhöhe (nur wenn der Wechsel keine 15 s her ist).
 */
(function () {
  'use strict';
  var D = document, W = window, KEY = 'r24fg_y';

  /* ---------- 3 · Produktseite: Scrollhöhe beim Farbwechsel mitnehmen ---------- */
  function ssGet() { try { return JSON.parse(W.sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function ssSet(v) { try { if (v) W.sessionStorage.setItem(KEY, JSON.stringify(v)); else W.sessionStorage.removeItem(KEY); } catch (e) { /* privat/gesperrt: ohne Merken weiter */ } }
  (function restore() {
    var s = ssGet(); if (!s) return;
    ssSet(null);
    if (s.to !== W.location.pathname || Date.now() - s.t > 15000 || !(s.y > 0)) return;
    /* Die Galerie/Bilder verschieben die Seite noch beim Laden — bis „load“ nachziehen, solange der Kunde nicht selbst scrollt. */
    W.R24FG_KEEP = 1; /* sections/r24-product-main: „oben()“ springt dann nicht an den Seitenanfang */
    /* Ziel: die Farbauswahl steht wieder an derselben Stelle im Fenster (Bilder/Titel der Farben sind unterschiedlich hoch); ohne Auswahl die alte Höhe. */
    var at = function () { var b = D.querySelector('[data-r24fg]'); return (b && s.off != null) ? Math.max(0, b.getBoundingClientRect().top + (W.pageYOffset || 0) - s.off) : s.y; };
    var own = false, go = function () { if (own) return; var y = at(); try { W.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { W.scrollTo(0, y); } };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { W.addEventListener(ev, function () { own = true; }, { once: true, passive: true }); });
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', go); else go();
    if (D.readyState !== 'complete') W.addEventListener('load', function () { go(); setTimeout(go, 150); }); else setTimeout(go, 150);
  })();

  /* ---------- 1 · Karte ---------- */
  function cardOf(el) { return el.closest('.r24col-card'); }
  function imgOf(card) { return card.querySelector('.r24col-card__media img'); }
  function preview(dot, on) {
    var card = cardOf(dot), img = card && imgOf(card); if (!img) return;
    if (on && dot.getAttribute('data-img')) {
      if (!img.hasAttribute('data-fg-src')) { img.setAttribute('data-fg-src', img.getAttribute('src') || ''); img.setAttribute('data-fg-set', img.getAttribute('srcset') || ''); }
      img.setAttribute('srcset', dot.getAttribute('data-set') || ''); img.setAttribute('src', dot.getAttribute('data-img'));
    } else if (!on && img.hasAttribute('data-fg-src')) {
      img.setAttribute('srcset', img.getAttribute('data-fg-set')); img.setAttribute('src', img.getAttribute('data-fg-src'));
      img.removeAttribute('data-fg-src'); img.removeAttribute('data-fg-set');
    }
  }
  function txt(el, s) { if (el) el.textContent = s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function apply(dot) {
    var card = cardOf(dot); if (!card) return;
    var cur = card.querySelector('.r24fg-dot.is-cur');
    var url = dot.getAttribute('href'), t = dot.getAttribute('data-t') || '';
    preview(dot, false);
    var img = imgOf(card);
    if (img && dot.getAttribute('data-img')) { img.setAttribute('srcset', dot.getAttribute('data-set') || ''); img.setAttribute('src', dot.getAttribute('data-img')); img.setAttribute('alt', t); }
    var media = card.querySelector('.r24col-card__media'); if (media) { media.setAttribute('href', url); media.setAttribute('aria-label', t); }
    var ti = card.querySelector('.r24col-card__title'); if (ti) { ti.setAttribute('href', url); txt(ti, t); }
    /* Frontfarbe in der Faktenzeile nur tauschen, wenn sie dort genau die bisherige Farbe nennt. */
    var f0 = card.querySelector('.r24col-card__facts span');
    if (f0 && cur && f0.textContent.trim() === (cur.getAttribute('data-l') || '').trim()) txt(f0, dot.getAttribute('data-l'));
    var now = dot.getAttribute('data-now') || '', old = dot.getAttribute('data-old') || '', pct = dot.getAttribute('data-pct') || '';
    var pr = card.querySelector('.r24col-card__price');
    if (pr) pr.innerHTML = old
      ? '<span class="r24col-card__old"><span class="r24col-sr">statt </span>' + esc(old) + '</span><span class="r24col-card__now is-sale"><span class="r24col-sr">jetzt </span>' + esc(now) + '</span>'
      : '<span class="r24col-card__now">' + esc(now) + '</span>';
    var sv = card.querySelector('.r24col-card__save');
    if (sv) { if (dot.getAttribute('data-save')) { sv.hidden = false; txt(sv, 'Sie sparen ' + dot.getAttribute('data-save')); } else sv.hidden = true; }
    var bd = card.querySelector('.r24col-badge--sale');
    if (bd) { if (pct) { bd.hidden = false; txt(bd, '−' + pct + '%'); } else bd.hidden = true; }
    var heart = card.querySelector('[data-r24-wish]');
    if (heart) { heart.setAttribute('data-id', dot.getAttribute('data-id')); heart.setAttribute('aria-label', 'Auf die Merkliste: ' + t); }
    var atc = card.querySelector('.r24col-card__atc');
    if (atc) {
      atc.setAttribute('href', url);
      if (atc.hasAttribute('data-variant-id')) {
        if (dot.getAttribute('data-one') === '1' && dot.getAttribute('data-av') === '1') atc.setAttribute('data-variant-id', dot.getAttribute('data-v'));
        else { atc.removeAttribute('data-action-atc'); atc.removeAttribute('data-variant-id'); atc.removeAttribute('role'); }
      }
    }
    [].forEach.call(card.querySelectorAll('.r24fg-dot'), function (d) {
      var on = d === dot; d.classList.toggle('is-cur', on);
      if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
    D.dispatchEvent(new CustomEvent('r24col:updated'));
  }
  D.addEventListener('mouseover', function (e) {
    var d = e.target.closest && e.target.closest('.r24fg-dot'); if (d && !d.classList.contains('is-cur')) preview(d, true);
  });
  D.addEventListener('mouseout', function (e) {
    var d = e.target.closest && e.target.closest('.r24fg-dot'); if (d && !(e.relatedTarget && d.contains(e.relatedTarget))) preview(d, false);
  });
  D.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-r24fg-go]');
    if (go) { var box = go.closest('[data-r24fg]'); ssSet({ to: new URL(go.href, W.location.href).pathname, y: W.pageYOffset || 0, off: box ? Math.round(box.getBoundingClientRect().top) : null, t: Date.now() }); return; }
    var d = e.target.closest && e.target.closest('.r24fg-dot'); if (!d) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (d.classList.contains('is-cur')) return; /* gezeigte Farbe → Produkt öffnen */
    e.preventDefault(); apply(d);
  });

  /* ---------- 2 · Raster: eine Karte je Farbgruppe ---------- */
  function dedupe() {
    [].forEach.call(D.querySelectorAll('.r24col-grid'), function (g) {
      var seen = {};
      [].forEach.call(g.children, function (c) {
        var k = c.getAttribute && c.getAttribute('data-fg');
        if (!k) return;
        if (c.hasAttribute('data-fg-dup')) { c.hidden = false; c.removeAttribute('data-fg-dup'); }
        if (seen[k]) { c.hidden = true; c.setAttribute('data-fg-dup', ''); } else seen[k] = 1;
      });
    });
  }
  var q = 0;
  function later() { if (q) return; q = 1; (W.requestAnimationFrame || setTimeout)(function () { q = 0; dedupe(); }); }
  function boot() {
    dedupe();
    if (W.MutationObserver) new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { later(); return; }
    }).observe(D.body, { childList: true, subtree: true });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  W.R24FG = { dedupe: dedupe, _apply: apply };
})();
